import PropTypes from 'prop-types';

export const StepPropTypes = {
  processStep: PropTypes.instanceOf(Function).isRequired,
};
